// ThemeContext.js
import React, { createContext, useContext, useEffect, useState, useRef } from 'react';

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [theme, setTheme] = useState(null);
    const companyIduseRef = useRef(''); // Replace with actual dynamic company ID

    useEffect(() => {
        // Load theme when component mounts
        loadTheme();
    }, [companyIduseRef.current]);

    const applyTheme = (theme) => {
        if (!theme) return;
        document.documentElement.style.setProperty('--web-background-color', theme.primaryColor || '#40513B');
        document.documentElement.style.setProperty('--sidemenu-dd-bg-color', theme.sideMenuDdBgColor || '#2C3829');
        document.documentElement.style.setProperty('--button-bg-color', theme.buttonBgColor || '#40513B');
        document.documentElement.style.setProperty('--button-hover-color', theme.buttonHoverColor || '#2e4a2e');
        document.documentElement.style.setProperty('--button-text-color', theme.buttonTextColor || '#ffffff');
        document.documentElement.style.setProperty('--QA-bg-color', theme.qaBgColor || '#609966');
        document.documentElement.style.setProperty('--sidemenu-dd-hover-color', theme.sideMenuDdHoverColor || '#3e7b61');
        document.documentElement.style.setProperty('--sidebar-icon-filter', theme.sidebarIconFilter || 'none');
        document.documentElement.style.setProperty('--sidemenu-selected-icon-color', theme.sideMenuSelectedIconColor || 'brightness(0) invert(1)');
        document.documentElement.style.setProperty('--sidemenu-selected-text-color', theme.sideMenuSelectedTextColor || '#ffffff');
        document.documentElement.style.setProperty('--sidemenu-text-color', theme.sideMenuTextColor || '#9DC08B');
        document.documentElement.style.setProperty('--sidemenu-user-info-color', theme.sideMenuUserInfoColor || '#ffffff');
        document.documentElement.style.setProperty('--sidemenu-role-text-color', theme.sideMenuRoleTextColor || '#9DC08B');
        document.documentElement.style.setProperty('--card-primary-bg-color', theme.cardPrimaryColor || '#40513B');
        document.documentElement.style.setProperty('--card-secondary-bg-color', theme.cardSecondaryColor || '#609966');
        document.documentElement.style.setProperty('--card-text-color', theme.cardTextColor || '#ffffff');
        document.documentElement.style.setProperty('--web-title-text-color', theme.webTitleTextColor || '#609966');
        document.documentElement.style.setProperty('--modal-title-color', theme.modalTitleColor || '#40513B');
        document.documentElement.style.setProperty('--tab-border', theme.tabBorder || '#a6a7cc');
        document.documentElement.style.setProperty('--tab-background', theme.tabBackground || '#a6a7cc');
    };
    
  

    
    const loadTheme = async () => {
        const themeId = localStorage.getItem(`themeId`);
        var selectedTheme = companyIduseRef.current || themeId || 0;
        // var selectedTheme = 4;
    
        const themes = {
            1: {
                primaryColor: "#40513B",
                sideMenuDdBgColor: "#2C3829",
                buttonBgColor: "#40513B",
                buttonHoverColor: "#2e4a2e",
                buttonTextColor: "#ffffff",
                qaBgColor: "#609966",
                sideMenuDdHoverColor: "#3e7b61",
                sidebarIconFilter: "none",
                sideMenuSelectedIconColor: "brightness(0) invert(1)",
                sideMenuSelectedTextColor: "#ffffff",
                sideMenuTextColor: "#9DC08B",
                sideMenuUserInfoColor: "#ffffff",
                sideMenuRoleTextColor: "#9DC08B",
                cardPrimaryColor: "#40513B",
                cardSecondaryColor: "#609966",
                cardTextColor: "#ffffff",
                webTitleTextColor: "#609966",
                modalTitleColor: "#40513B",
                tabBorder: "#9DC08B",
                tabBackground: "#edf1d6",
            },
            2: {
                primaryColor: "#636D79",
                sideMenuDdBgColor: "#3A4652",
                buttonBgColor: "#5A55D2",
                buttonHoverColor: "#4943B8",
                buttonTextColor: "#ffffff",
                qaBgColor: "#82C1A4",
                sideMenuDdHoverColor: "#2E3A44",
                sidebarIconFilter: "brightness(70%) invert(100%)",
                sideMenuSelectedIconColor: "sepia(70) saturate(60) hue-rotate(20deg) brightness(2)",
                sideMenuSelectedTextColor: "#FFCA00",
                sideMenuTextColor: "#FFFFFF",
                sideMenuUserInfoColor: "#ffffff",
                sideMenuRoleTextColor: "#C1C1C1",
                cardPrimaryColor: "#838C89",
                cardSecondaryColor: "#4D4E8E",
                cardTextColor: "#ffffff",
                webTitleTextColor: "#4D4E8E",
                modalTitleColor: "#40513B",
                tabBorder: "#a6a7cc",
                tabBackground: "#D6E1F1",
            },
            3: {
                primaryColor: "#F38181",
                sideMenuDdBgColor: "#D96A6A",
                buttonBgColor: "#F38181",
                buttonHoverColor: "#D96C6C",
                buttonTextColor: "#ffffff",
                qaBgColor: "#FCE38A",
                sideMenuDdHoverColor: "#C55858",
                sidebarIconFilter: "brightness(0) invert(1)",
                sideMenuSelectedIconColor: "sepia(110) saturate(0) hue-rotate(50deg) brightness(2)",
                sideMenuSelectedTextColor: "#EAFFD0",
                sideMenuTextColor: "#ffffff",
                sideMenuUserInfoColor: "#ffffff",
                sideMenuRoleTextColor: "#333333",
                cardPrimaryColor: "#95E1D3",
                cardSecondaryColor: "#FCE38A",
                cardTextColor: "#363535",
                webTitleTextColor: "#FCE38A",
                modalTitleColor: "#40513B",
                tabBorder: "#F6ACAC",
                tabBackground: "#fbf3f3",
            },
            4: {
                primaryColor: "#FAE3D9",
                sideMenuDdBgColor: "#E7B3BD",
                buttonBgColor: "#FFB6B9",
                buttonHoverColor: "#EFA0A3",
                buttonTextColor: "#000",
                qaBgColor: "#d9b9ab",
                sideMenuDdHoverColor: "#D9A79F",
                sidebarIconFilter: "brightness(0) invert(0)",
                sideMenuSelectedIconColor: "sepia(80%) saturate(120%) hue-rotate(145deg) brightness(0.95)",
                sideMenuSelectedTextColor: "#52A8A7",
                sideMenuTextColor: "#000",
                sideMenuUserInfoColor: "#111111",
                sideMenuRoleTextColor: "#333333",
                cardPrimaryColor: "#61C0BF",
                cardSecondaryColor: "#BBDED6",
                cardTextColor: "#363535",
                webTitleTextColor: "#be9e92",
                modalTitleColor: "#40513B",
                tabBorder: "#e7beac",
                tabBackground: "#fff9f7",
            },
            5: {
                primaryColor: "#B99470",
                sideMenuDdBgColor: "#9B846D",
                buttonBgColor: "#B99470",
                buttonHoverColor: "#A37F5E",
                buttonTextColor: "#FBFBFB",
                qaBgColor: "#ccc281",
                sideMenuDdHoverColor: "#A27F5C",
                sidebarIconFilter: "brightness(0) invert(1)",
                sideMenuSelectedIconColor: "brightness(0) invert(1)",
                sideMenuSelectedTextColor: "#EDF1D6",
                sideMenuTextColor: "#FFE0CB",
                sideMenuUserInfoColor: "#ffffff",
                sideMenuRoleTextColor: "#333333",
                cardPrimaryColor: "#5F6F52",
                cardSecondaryColor: "#A9B388",
                cardTextColor: "#ffffff",
                webTitleTextColor: "#B99470",
                modalTitleColor: "#40513B",
                tabBorder: "#d3b496",
                tabBackground: "#fff8f2",
            },
            default: {
                primaryColor: "#40513B",
                sideMenuDdBgColor: "#2C3829",
                buttonBgColor: "#40513B",
                buttonHoverColor: "#2e4a2e",
                buttonTextColor: "#ffffff",
                qaBgColor: "#609966",
                sideMenuDdHoverColor: "#3e7b61",
                sidebarIconFilter: "none",
                sideMenuSelectedIconColor: "brightness(0) invert(1)",
                sideMenuSelectedTextColor: "#ffffff",
                sideMenuTextColor: "#9DC08B",
                sideMenuUserInfoColor: "#ffffff",
                sideMenuRoleTextColor: "#9DC08B",
                cardPrimaryColor: "#40513B",
                cardSecondaryColor: "#609966",
                cardTextColor: "#ffffff",
                webTitleTextColor: "#609966",
                modalTitleColor: "#40513B",
                tabBorder: "#9DC08B",
                tabBackground: "#edf1d6",

            }
        };
    
        const theme = themes[selectedTheme] || themes.default;
        setTheme(theme);
        applyTheme(theme);
    };
    
    

    // Function to update the company ID
    const setCompanyId = (newCompanyId) => {
        companyIduseRef.current = newCompanyId;
        loadTheme()
    };



    return (
        <GlobalContext.Provider value={{ theme, setCompanyId }}>
            {children}
        </GlobalContext.Provider>
    );
};

export const useTheme = () => useContext(GlobalContext);
